module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner--rules-593edd6aa4684d8a03ec56986db41edf.jpg";